module.exports = __webpack_public_path__ + "static/media/quality.c5527fb0.png";